import { createSelector } from 'reselect';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  illiquidSecurityAllIds,
  illiquidSecurityById,
  allIlliquidSecuritiesSelector,
] = resourceSelectors('illiquidSecurities');
